<template>
  <div class="filter-option">
    <Toggle :selected="option.selected" @click="onToggle" :disabled="option.matches === 0 || !showMatchesFilter" />
    <label :for="option.code">
      <span
        :class="`filter-option__text ${option.selected && 'filter-option__text--selected'} ${option.matches === 0 && 'filter-option__text--disabled'}`"
      >
        {{ translate(option.label) }} ({{ showMatchesFilter ? option.matches : 0 }})</span
      >
    </label>
  </div>
</template>

<script>
import FilterOption from '../../domain/FilterOption'
import Toggle from '../shared/Toggle'

export default {
  name: 'FilterOptionMobileComponent',
  components: { Toggle },
  props: {
    option: {
      type: FilterOption
    },
    showNumberOfMatches: {
      type: Boolean,
      defaultValue: false
    },
    selectedRoomCode: {
      type: String
    },
    numberOfRoomsLeftByRoomId: {
      type: Array
    }
  },
  methods: {
    onToggle() {
      this.option.selected ? this.$emit('unselect', this.option) : this.$emit('select', this.option)
    }
  },
  computed: {
    showMatchesFilter() {
      const soldOutRooms = this.numberOfRoomsLeftByRoomId
        .filter(room => room.numberOfRoomsLeft === 0)
        .map(room => room.id)
      const isRoomSoldOut = this.option?.roomIds.some(roomId => soldOutRooms.includes(roomId))
      const isSelectedRoomIncluded = this.option?.roomIds.some(roomId => roomId === this.selectedRoomCode)

      return !isRoomSoldOut || isSelectedRoomIncluded
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-option {
  display: flex;
  padding: 1rem 3rem;

  &__text {
    padding-inline-start: 1rem;
    font-weight: normal;
    font-size: 12px;
    &--selected {
      font-weight: bold;
    }
    &--disabled {
      color: #cccccc;
    }
  }
}
</style>
